import { render, staticRenderFns } from "./cat-complete-flow-modal.vue?vue&type=template&id=3b8faba4&"
import script from "./cat-complete-flow-modal.vue?vue&type=script&lang=js&"
export * from "./cat-complete-flow-modal.vue?vue&type=script&lang=js&"
import style0 from "./cat-complete-flow-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports